import { useEffect } from 'react';

export interface LightboxProps {
  /** 大图 URL（objectURL / 远程地址） */
  url: string;
  onClose: () => void;
}

/** 图片点击放大（全屏预览）：点遮罩或 ✕ 关闭，ESC 关闭。 */
export function Lightbox({ url, onClose }: LightboxProps): JSX.Element {
  useEffect(() => {
    const onKey = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-black/85 p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="图片预览"
    >
      <img
        src={url}
        alt=""
        className="max-h-full max-w-full rounded-btn object-contain shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      />
      <button
        type="button"
        aria-label="关闭预览"
        className="absolute right-4 top-4 rounded-btn bg-black/40 px-3 py-2 text-xl text-white/80 hover:bg-black/60 hover:text-white"
        onClick={onClose}
      >
        ✕
      </button>
    </div>
  );
}

export default Lightbox;
